import styled from '@emotion/styled'
import {AccountBalance, AccountBox, BarChart, ExitToApp, Star} from '@mui/icons-material'
import graphql from 'babel-plugin-relay/macro'
import React from 'react'
import {useFragment} from 'react-relay'
import {Link} from 'react-router-dom'


import {PALETTE} from '../styles/paletteV3'
import {SIGNOUT_LABEL, SIGNOUT_SLUG} from '../utils/constants'
import DropdownMenuLabel from './DropdownMenuLabel'
import Menu from './Menu'
import MenuItem from './MenuItem'
import MenuItemHR from './MenuItemHR'
import MenuItemIcon from './MenuItemIcon'
import MenuItemLabel from './MenuItemLabel'

const UpgradeIcon = styled(MenuItemIcon)({
  color: PALETTE.SKY_500
})

const UpgradeCTA = styled('span')({
  color: PALETTE.SKY_500,
  fontSize: 15,
  lineHeight: '32px',
  marginRight: '2rem'
})

const TallMenu = styled(Menu)({
  maxHeight: 256
})

const MenuItemLink = MenuItemLabel.withComponent(Link)






const StandardHubUserMenu = (props) => {
  const {menuProps, viewerRef} = props
  const viewer = useFragment(
    graphql`
      fragment StandardHubUserMenu_viewer on User {
        email
        featureFlags {
          insights
        }
        organizations {
          id
          billingTier
        }
      }
    `,
    viewerRef
  )
  const {email, featureFlags, organizations} = viewer
  const {insights} = featureFlags
  const ownedFreeOrgs = organizations.filter((org) => org.billingTier === 'starter')
  const showUpgradeCTA = ownedFreeOrgs.length > 0
  const routeSuffix = ownedFreeOrgs.length === 1 ? `/${ownedFreeOrgs[0].id}` : ''

  return (
    React.createElement(TallMenu, { ariaLabel: 'Select your settings', ...menuProps,}
      , React.createElement(DropdownMenuLabel, null, email)
      , React.createElement(MenuItem, {
        label: 
          React.createElement(MenuItemLink, { to: '/me/profile',}
            , React.createElement(MenuItemIcon, null
              , React.createElement(AccountBox, null )
            )
            , 'My Settings'
          )
        ,}
      )
      , React.createElement(MenuItem, {
        label: 
          React.createElement(MenuItemLink, { to: '/me/organizations',}
            , React.createElement(MenuItemIcon, null
              , React.createElement(AccountBalance, null )
            )
            , 'Organizations'
          )
        ,}
      )
      , insights && (
        React.createElement(MenuItem, {
          label: 
            React.createElement(MenuItemLink, { to: '/usage',}
              , React.createElement(MenuItemIcon, null
                , React.createElement(BarChart, null )
              )
              , 'Usage'
            )
          ,}
        )
      )
      , showUpgradeCTA && React.createElement(MenuItemHR, { key: "HR0",} )
      , showUpgradeCTA && (
        React.createElement(MenuItem, {
          label: 
            React.createElement(MenuItemLink, { to: `/me/organizations${routeSuffix}`,}
              , React.createElement(UpgradeIcon, null
                , React.createElement(Star, null )
              )
              , React.createElement(UpgradeCTA, null, 'Upgrade')
            )
          ,}
        )
      )
      , React.createElement(MenuItemHR, { key: "HR1",} )
      , React.createElement(MenuItem, {
        label: 
          React.createElement(MenuItemLink, { to: `/${SIGNOUT_SLUG}`,}
            , React.createElement(MenuItemIcon, null
              , React.createElement(ExitToApp, null )
            )
            , SIGNOUT_LABEL
          )
        ,}
      )
    )
  )
}

export default StandardHubUserMenu
